<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title
                        style="background-color: #2b3990"
                    >
                                            <span
                                                class="headline white--text"
                                            >{{ titleForm }}</span
                                            >
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form ref="form" lazy-validation>
                                <v-row>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-select
                                            v-model="newServiceCode"
                                            label="Service Code"
                                            :items="codes"
                                            :rules="requiredRules"
                                            item-value="Code"
                                            item-text="Code"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-select
                                            v-model="newTitle"
                                            label="Service Code Title"
                                            :items="codes"
                                            :rules="requiredRules"
                                            item-value="Title"
                                            item-text="Title"
                                            disabled
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-select
                                            v-model="newUnits"
                                            label="Service Units"
                                            :items="codes"
                                            :rules="requiredRules"
                                            item-value="Unit"
                                            item-text="Unit"
                                            disabled
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-text-field
                                            v-model="newAnnualUnits"
                                            label="Annual Units"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3" v-if="showNevadaFields">
                                        <v-text-field
                                            v-model="newTotalUnits"
                                            label="Total Units"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3" v-if="showNevadaFields">
                                        <v-text-field
                                            v-model="newAuthUnits"
                                            label="Authorized Units"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3" v-if="showNevadaFields">
                                        <v-text-field
                                            v-model="newAuthHours"
                                            label="Authorized Hours"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            v-model="newRate"
                                            label="Rate"
                                            prefix="$"
                                            :rules="requiredRules"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-menu
                                            ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newStartDate"
                                                    label="Start Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    clearable
                                                    :rules="requiredRules"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="newStartDate"
                                                no-title
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-menu
                                            ref="menu2"
                                            v-model="menu2"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newEndDate"
                                                    label="End Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    clearable
                                                    :rules="requiredRules"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="newEndDate"
                                                no-title
                                                scrollable
                                                :min="minEndDate"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.menu2.save(date)">OK</v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-switch
                                            v-model="isActive"
                                            :label="isActive ? 'Active' : 'Deactive'"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="Service Auth"
                                            v-model="newServiceAuth"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="Contract Number"
                                            v-model="newContractNumber"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>


                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!createNewServiceCode"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="addServiceCode()"
                            v-if="createNewServiceCode"
                        >Save
                        </v-btn
                        >
                        <v-btn
                            color="blue darken-1 white--text"
                            @click="updateServiceCode()"
                            v-if="!createNewServiceCode"
                        >Update
                        </v-btn
                        >
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close"
                        >Cancel
                        </v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from "axios";
import Foot from "@/components/Footer";
import ClientNav from "@/components/ClientNav.vue";
import DateTimeUtil from "../../../../utils/date-time.util";
import {displayError, displaySuccess} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";

const url = require("../../../client_config/config").url;

export default {
    components: {
        Foot,
        ClientNav
    },
    data: function () {
        return {
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu: false,
            menu2: false,
            newCode: false,
            msg: false,
            search: "",
            text: "",
            serviceCode: {},
            disabled: [],
            tempData: [],
            codes: [],
            clientID: this.$route.params.clientID,
            serviceCodeId: this.$route.params.id,
            token: localStorage.getItem('token'),
            titleForm: "New Service Code",
            units: ["Daily", "Quarter Hour", "Session"],
            serviceCodeID: "",
            newTitle: "",
            newServiceCode: "",
            newAnnualUnits: "",
            newTotalUnits: "",
            newAuthHours: "",
            newAuthUnits: "",
            newUnits: "",
            newRate: "",
            newServiceAuth: "",
            newContractNumber: "",
            newStartDate: this.date,
            newEndDate: this.date,
            showNevadaFields: false,
            editedIndex: -1,
            editedItem: {
                serviceCode: "",
                annualUnits: "",
                rate: "",
                startDate: "",
                endDate: "",
                active: "",
            },
            defaultItem: {
                serviceCode: "",
                annualUnits: "",
                rate: "",
                startDate: "",
                endDate: "",
                active: "",
            },
            isActive: true,
            isLoading: true,
            requiredRules: [(v) => !!v || "This is required"],
            createNewServiceCode: false,
        };
    },

    computed: {
        minEndDate() {
            return this.newStartDate ? this.newStartDate : null;
        },
    },

    watch: {
        newServiceCode(val) {
            this.codes.forEach((code) => {
                if (code.Code === val) {
                    this.newUnits = code.Unit;
                    this.newTitle = code.Title;

                    // Check the state associated with the service code
                    if (code.State === "Nevada") {
                        this.showNevadaFields = true;
                    } else {
                        this.showNevadaFields = false;
                    }
                }
            });

            //this.newUnits = val;
        },
    },

    async created() {
        this.createNewServiceCode = this.$route.query.newServiceCode === 'true';
        await this.getCodes();
    },

    async mounted() {
        if (!this.createNewServiceCode) {
            await this.getServiceCode();
        }

        window.addEventListener('keydown', async (event) => {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, this.downloadUrl, this.serviceCodeId, this.token, 'ServiceCode');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.serviceCodeId, this.token, 'ServiceCode');
        });
    },

    methods: {

        initialize() {
            this.serviceCodes = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        viewServiceCode(item) {
            this.titleForm = "Viewing " + item.ServiceCode;
            this.newServiceCode = item.ServiceCode;
            this.newTitle = item.Title;
            this.newAnnualUnits = item.AnnualUnits;
            this.newTotalUnits = item.TotalUnits;
            this.newAuthHours = item.AuthHours;
            this.newAuthUnits = item.AuthUnits;
            this.newUnits = item.Units;
            this.newRate = item.Rate;
            this.newServiceAuth = item.ServiceAuth;
            this.newContractNumber = item.ContractNumber;
            // this.newStartDate =
            //     item.StartDate === "Invalid date"
            //         ? null
            //         : DateTimeUtil.toLocalDate(item.StartDate);
            // this.newEndDate =
            //     item.EndDate === "Invalid date"
            //         ? null
            //         : DateTimeUtil.toLocalDate(item.EndDate);
            this.newStartDate = DateTimeUtil.toLocalDate(item.StartDate);
            this.newEndDate = DateTimeUtil.toLocalDate(item.EndDate);
            this.isActive = item.Active === "Active" ? true : false;
            this.serviceCodeId = item._id;

            console.log(item);
        },

        close() {
            this.clear();
            this.$router.go(-1);
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        clear() {
            this.newServiceCode = "";
            this.newTitle = "";
            this.newAnnualUnits = "";
            this.newTotalUnits = "";
            this.newAuthUnits = "";
            this.newAuthHours = "";
            this.newUnits = "";
            this.newRate = "";
            this.newServiceAuth = "";
            this.newContractNumber = "";
            this.newStartDate = this.date;
            this.newEndDate = this.date;
            this.isActive = "";
        },

        async updateServiceCode() {
            await this.$nextTick(); // Ensure any pending DOM updates are completed

            let validate = this.$refs.form.validate();

            if (!validate) {
                this.snackbarColor = "red";
                this.msg = true;
                this.text = "Please fill all required fields.";
                return false;
            }

            // Rest of your code for updating service code
            let req_body = {
                ServiceCode: this.newServiceCode,
                Title: this.newTitle,
                AnnualUnits: this.newAnnualUnits,
                TotalUnits: this.newTotalUnits,
                AuthUnits: this.newAuthUnits,
                AuthHours: this.newAuthHours,
                Units: this.newUnits,
                Rate: this.newRate,
                ServiceAuth: this.newServiceAuth,
                ContractNumber: this.newContractNumber,
                StartDate: this.newStartDate,
                EndDate: this.newEndDate,
                Active: this.isActive ? "Active" : "Deactive",
            };

            try {
                const response = await axios.put(`${url}/serviceCodes/${this.serviceCodeId}`, req_body);
                this.getServiceCodes();

                if (response.status !== 200) {
                    displayError("There was an error updating the service code.");
                    return;
                }
                displaySuccess("The service code has been updated successfully.");
                this.getServiceCodes();
            } catch (error) {
                console.error("Error updating service code:", error);
            } finally {
                this.close();
            }
        },

        getServiceCode() {
            this.isLoading = true;
            axios.get(`${url}/serviceCodes/${this.serviceCodeId}`)
                .then((res) => {
                    this.serviceCode = res.data.serviceCode;

                    if (this.serviceCode.Active === 'Deactive') {
                        this.disabled = res.data.serviceCode
                        this.isActive = false;
                    }

                    this.viewServiceCode(this.serviceCode)
                })
                .finally(() => (this.isLoading = false));
        },

        async addServiceCode() {
            let validate = this.$refs.form.validate();

            if (validate === false) {
                this.snackbarColor = "red";
                this.msg = true;
                this.text = "Please fill all required fields.";
                return false;
            }
            let req_body = {
                ServiceCode: this.newServiceCode,
                Title: this.newTitle,
                AnnualUnits: this.newAnnualUnits,
                TotalUnits: this.newTotalUnits,
                AuthHours: this.newAuthHours,
                AuthUnits: this.newAuthUnits,
                Units: this.newUnits,
                Rate: this.newRate,
                ServiceAuth: this.newServiceAuth,
                ContractNumber: this.newContractNumber,
                StartDate: this.newStartDate,
                EndDate: this.newEndDate,
                Active: this.isActive ? "Active" : "Deactive",
                ClientID: this.clientID,
            };

            try {
                const response = await axios.post(`${url}/serviceCodes`, req_body);
                this.getServiceCodes();

                if (response.status !== 200) {
                    displayError("There was an error adding the document.");
                    return;
                }
                displaySuccess("The service code has been created successfully.");
                this.getServiceCodes();
            } catch (error) {
                console.error("Error saving service code:", error);
            } finally {
                this.close();
            }
        },

        getCodes() {
            axios.get(`${url}/codes`).then((res) => {
                this.codes = res.data.codes;
            });
        },

        getServiceCodes() {
            this.isLoading = true;
            axios
                .get(`${url}/serviceCodes/get/allClientCodes/${this.clientID}`)
                .then((res) => {
                    this.serviceCodes = res.data.activeServiceCodes;
                    this.disabled = res.data.inactiveServiceCodes;
                })
                .finally(() => (this.isLoading = false));
        },

        async generateDownloadUrl() {
            return `${url}/serviceCodes/print?id=${this.serviceCodeId}`;
        },

        async showPrintModal() {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(this.downloadUrl, this.serviceCodeId, this.token,'ServiceCodeForm');
        },

    },
};
</script>
